import {NodeChunk} from "../../chunks/types/NodeChunk";

export function getIsExportedFromNodeChunk(
  nodeChunk: NodeChunk
): boolean {
  const {
    captures: {
      1: exportChunk
    }
  } = nodeChunk;
  return !!exportChunk;
}
